import angular from 'angular';
import uiRouter from 'angular-ui-router';
import confirmRegistrationComponent from './confirmRegistration.component';

let confirmRegistrationModule = angular.module('confirmRegistration', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('confirmRegistration', {
    url: '/confirmRegistration/:key',
    component: 'confirmRegistration',
    params: {
      key: null
    }
  });
})

.component('confirmRegistration', confirmRegistrationComponent)

.name;

export default confirmRegistrationModule;



// WEBPACK FOOTER //
// ./client/app/components/confirmRegistration/confirmRegistration.js